<template>
  <custom-dialog title="手机号核券" :showClose="true" width="814px" v-if="visibleShow" :visible="visibleShow" @close="close"
    :close-on-click-modal="false" :close-on-press-escape="false" @save="save">
    <div slot="content">
      <div class="content_patient">
        <div class="content_patient_phone">
          <div>会员手机：</div>
          <el-input class="w240 mr8" v-model.trim="phone"></el-input>
          <el-button type="primary" @click="search">查券</el-button>
        </div>
        <div>会员姓名：{{memberName}}</div>
      </div>
      <div class="content_coupon">
        <el-empty v-if="usableList.length == 0 && unusableList.length == 0" :image="imgArr.noCoupon" description="暂无可用券"></el-empty>
        <div v-else>
          <div class="useable_warp" v-if="usableList.length > 0">
            <div class="content_coupon_title">
              <div class="content_coupon_title_text">可用券</div>
            </div>
            <div class="coupon_list">
              <div v-for="item in usableList" :key="item.couId" :class="{ 'coupon_list_item': true, 'coupon_list_item_active': activeIds.includes(item.couId), 'disabled': !item.usable }" @click="changeCoupon(item)">
                <el-checkbox :value="activeIds.includes(item.couId)" class="coupon_list_item_check"></el-checkbox>
                <div class="coupon_list_item_type" v-tip.dark.top="item.couName">{{item.couName}}</div>
                <!-- <div class="coupon_list_item_type">{{computedDictText(item.newType, couTypeList)}}</div> -->
                <div class="coupon_list_item_price">
                  <span>￥</span>
                  <span class="size28">{{item.couMoney}}</span>
                </div>
                <div class="coupon_list_item_tips" v-if="item.couFloorMoney > 0">满{{ item.couFloorMoney }}可用</div>
                <div class="coupon_list_item_tips" v-else>无门槛券</div>
                <div class="coupon_list_item_date" :class="{'unUseable':item.willExpire}">{{ computedDate(item.couEndTime)}} 到期</div>
                <div class="coupon_list_item_unusable">{{ item.usable ? '' : '不可叠加使用' }}</div>
              </div>
            </div>
          </div>
          <el-empty v-if="usableList.length == 0" :image="imgArr.noCoupon" description="暂无可用券"></el-empty>
          <div class="unUseable_warp" v-if="unusableList.length > 0">
            <div class="content_coupon_title">
              <div class="content_coupon_title_text">不可用券</div>
              <div class="content_coupon_title_more" @click="showMore = !showMore">
                <span class="color1890">{{ showMore ? '收起' : '展开' }}</span>
                <i :class="showMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
              </div>
            </div>
            <div class="coupon_list" v-if="showMore">
              <div class="coupon_list_item disabled" v-for="item in unusableList" :key="item.couId">
                <el-checkbox class="coupon_list_item_check" disabled></el-checkbox>
                <div class="coupon_list_item_type" v-tip.dark.top="item.couName">{{item.couName}}</div>
                <div class="coupon_list_item_price">
                  <span>￥</span>
                  <span class="size28">{{item.couMoney}}</span>
                </div>
                <div class="coupon_list_item_tips" v-if="item.couFloorMoney > 0">满{{ item.couFloorMoney }}可用</div>
                <div class="coupon_list_item_tips" v-else>无门槛券</div>
                <div class="coupon_list_item_date" :class="{'unUseable':item.willExpire}">{{ computedDate(item.couEndTime)}} 到期</div>
                <div class="coupon_list_item_reason" v-if="item.cantUseReason">{{ item.cantUseReason }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div slot="footer"></div> -->
  </custom-dialog>
</template>

<script>
import customDialog from '@/components/customDialog/CustomDialog'
import { getCouponList } from '@/api/coupon'
import { couTypeList } from '@/utils/const'
import { dictText,isNull } from '@/utils/validateBase'
import { imgArr } from '@/assets/images/img'
import { debounce } from 'lodash'
export default {
  components: { customDialog },
  props: {
    visibleShow: {
      type: Boolean,
      default: false
    },
    dialogObj: {
      type: Object,
      default:()=>{
        return {}
      }
    },
  },
  watch:{
    dialogObj: {
      immediate: true,
      deep: true,
      handler() {
        this.phone = this.dialogObj.phone
        this.activeIds = isNull(this.dialogObj.activeIds) ? [] : this.dialogObj.activeIds
      }
    }
  },
  data() {
    return {
      showMore: false,
      unusableList:[],
      usableList:[],
      couTypeList: couTypeList,
      memberName:'',
      memberId:'',
      activeIds: [],
      imgArr:imgArr,
      phone:''
    }
  },
  created() {
    this.getCouponList()
  },
  computed: {
    computedDictText() {
      return function (value, list) {
        return dictText(value, list)
      }
    },
    computedDate() {
      return function (value) {
        return this.$moment(value).format('YYYY-MM-DD')
      }
    },
  },
  methods: {
    close() {
      this.$emit('close',this.dialogObj.resource)
    },
    search() {
      this.activeIds = []
      this.getCouponList()
    },
    async getCouponList(){
      let { code, data } = await getCouponList({
        orderId: this.dialogObj.orderId,
        phone: this.phone,
        couponIds: this.activeIds
      })
      if(code === 200){
        this.memberId = data.memberId || ''
        this.memberName = data.memberName || ''
        this.unusableList = data.unusableList || []
        this.usableList = data.usableList || []
      }
    },
    changeCoupon:debounce(function (item) { 
      if (!item.usable) {
        return false
      }
      const couponIndex = this.activeIds.findIndex(v => v === item.couId)
      if (couponIndex > -1) {
        this.activeIds.splice(couponIndex, 1)
      } else {
        this.activeIds.push(item.couId)
      }
      this.getCouponList()
    },true,300),
    save(){
      if(this.activeIds.length === 0){
        return this.$message.error('请选择券')
      }
      const couponSelectList = this.usableList.filter(item => this.activeIds.includes(item.couId))
      this.$emit('save',{
        memberId: this.memberId,
        couponIds: this.activeIds,
        memberPhone:this.phone,
        discountAmount: couponSelectList.reduce((a, b) => { return this.$bigNumber(a,'+',b.discountAmount,2) }, 0)
      })
    }

  }
}
</script>

<style lang="less" scoped>
.disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.unUseable {
  color: #F54A45 !important;
}
/deep/.dialog-content{
  border-bottom: 1px solid #E0E0E0;
  max-height: 600px;
  overflow: auto;
}

.content_patient {
  color: #000000;
  font-size: 14px;
  padding-bottom: 16px;
  border-bottom: 1px dashed #E0E0E0;
}

.content_patient_phone {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}

.content_coupon {
  padding: 18px 0;
}

.useable_warp {}

.content_coupon_title {
  display: flex;
  align-items: center;
  padding-left: 6px;
  border-left: 2px solid #1890FF;
}

.content_coupon_title_text {
  color: #000000;
  font-size: 16px;
  font-weight: bold;
}

.coupon_list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 20px;
}

.coupon_list_item {
  width: 180px;
  // height: 140px;
  padding: 32px 12px 16px;
  background: #FFF8E8;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08);
  border-radius: 8px 8px 8px 8px;
  border: 1px solid #FFDB8A;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
}

.coupon_list_item_active {
  border: 1px solid #1890FF;
}

.coupon_list_item_check {
  box-sizing: border-box;
  position: absolute;
  top: 6px;
  left: 6px;
  width: 20px;
  height: 20px;
}

.coupon_list_item_check /deep/ .el-checkbox__inner {
  box-sizing: border-box;
  width: 20px;
  height: 20px;
  background-color: #FFFFFF;
  border: 1px solid #FFDB8A;
  border-radius: 4px;
}

.coupon_list_item_check /deep/ .el-checkbox__inner::after {
  left: 6px;
  width: 4px;
  height: 12px;
}

.coupon_list_item_check /deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #1890FF;
  border-color: #1890FF;
}

.coupon_list_item_check /deep/ .el-checkbox__input.is-checked .el-checkbox__inner::after {
  border-color: #FFFFFF;
}

.coupon_list_item_type {
  padding: 0 4px;
  width: fit-content;
  max-width: 140px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  height: 24px;
  text-align: center;
  line-height: 24px;
  color: #68481D;
  font-size: 12px;
  font-weight: 500;
  background: #FFE6AC;
  border-radius: 0px 8px 0px 8px;
  position: absolute;
  right: 0;
  top: 0;
}

.coupon_list_item_price {
  color: #68481D;
  font-weight: bold;
  font-size: 18px;
}

.coupon_list_item_tips {
  color: #68481D;
  font-size: 14px;
  margin-top: 8px;
}

.coupon_list_item_date {
  color: #989085;
  font-size: 13px;
  margin-top: 8px;
}

.coupon_list_item_unusable {
  margin: 8px 0 0 0;
  height: 13px;
  line-height: 13px;
  color: #F54A45;
  font-size: 13px;
}

.unUseable_warp {
  margin-top: 24px;
}

.content_coupon_title_more {
  margin-left: 8px;
  cursor: pointer;
}
.coupon_list_item_reason{
  padding-top: 8px;
  color: #F54A45;
  font-size: 13px;
  line-height: 16px;
  border-top: 1px dashed #E0E0E0;
  margin-top: 8px ;
}
</style>